import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory } from 'react-router-dom';
import './CoursesNav.scss';
import Button from '../../../Button';
import {
  onDemandCourses,
  liveCourses,
} from '../../../../utility/navLinks/headerNavLinks';
import CaretDownIcon from '../../../Icons/CaretDownIcon';

const coursesNav = [onDemandCourses, liveCourses];

// this is temporary solution, until we have links for both courses pages
const EmptyLink = ({ children }) => <>{children}</>;

const CoursesNav = ({ onClose }) => {
  const [expandedNavItemIds, setExpandedNavItemIds] = useState([
    'ondemand-courses',
    'live-courses',
  ]);
  const className = 'c-CoursesNav';

  const history = useHistory();

  const toggleNavItem = (id) => {
    setExpandedNavItemIds((navIds) => {
      if (navIds.includes(id)) {
        // Remove
        return navIds.filter((navId) => navId !== id);
      }

      // Add
      return [...navIds, id];
    });
  };

  const joinFreeTrial = () => {
    history.push('/trial');
  };

  const listWrapperClassName = `${className}__course-nav__item__list-wrapper`;

  return (
    <div className={className}>
      <div className={`${className}__container`}>
        <div className={`${className}__courses-container`}>
          {coursesNav.map((nav, key) => {
            const { id, name, link, subLinks } = nav;
            const isExpanded = expandedNavItemIds.includes(id);
            const listWrapperClassNames = [
              listWrapperClassName,
              isExpanded ? ` ${listWrapperClassName}--expanded` : '',
            ].join('');

            const arrowContainerClassNames = [
              `${className}__right-arrow`,
              isExpanded ? ` ${className}__right-arrow--rotate` : '',
            ].join('');

            // this solution will be abandoned when we have both courses pages
            const ConditionalLink = link ? Link : EmptyLink;

            return (
              <div key={key} className={`${className}__course-nav`}>
                <div
                  className={`${className}__course-nav__item__row`}
                  onClick={() => toggleNavItem(id)}
                >
                  <ConditionalLink to={link}>
                    <div
                      className={`${className}__course-nav__item__row__title-wrapper`}
                    >
                      <p
                        className={`${className}__course-nav__item__row__title`}
                      >
                        {name}
                      </p>
                    </div>
                  </ConditionalLink>
                  <div
                    className={`${arrowContainerClassNames} ${className}__dropdown-arrow-wrapper`}
                  >
                    <CaretDownIcon />
                  </div>
                </div>
                <div className={listWrapperClassNames}>
                  <ul className={`${className}__course-nav__item__list`}>
                    {subLinks.map((subNav, key1) => {
                      const { name, link, external } = subNav;
                      return (
                        <li
                          key={`${key}-${key1}`}
                          className={`${className}__course-nav__item__list__item`}
                          onClick={onClose}
                        >
                          {external ? (
                            <Link
                              title={name}
                              to={{ pathname: link }}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {name}
                            </Link>
                          ) : (
                            <Link to={link} title={name}>
                              {name}
                            </Link>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
        <div className="desktop-only">
          <div className={`${className}__free-trial-msg-container`}>
            <div className={`${className}__free-trial-msg`}>
              <span>Commitment issues?</span>
              <span className={`${className}__free-trial-msg--highlighted`}>
                {' '}
                Try Nas Academy class for free!
              </span>
            </div>
            <div className={`${className}__btn-container`}>
              <Button displayType="form-primary" onClick={joinFreeTrial}>
                Join Free Trial
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CoursesNav.propTypes = {
  onClose: PropTypes.func,
};

export default CoursesNav;
